import { useEffect } from "react";

const rules = [
  "WebView",
  "(iPhone|iPod|iPad)(?!.*Safari/)",
  "Android.*(wv|.0.0.0)",
];

const regex = new RegExp(`(${rules.join("|")})`, "ig");

export const getMobileDetect = (userAgent: NavigatorID["userAgent"]) => {
  const isAndroid = () => Boolean(userAgent?.match(/Android/i));
  const isIos = () => Boolean(userAgent?.match(/iPhone|iPad|iPod/i));
  const isOpera = () => Boolean(userAgent?.match(/Opera Mini/i));
  const isWindows = () => Boolean(userAgent?.match(/IEMobile/i));
  const isSSR = () => Boolean(userAgent?.match(/SSR/i));
  const isWebView = () => Boolean(userAgent?.match(regex));
  const isMobile = () =>
    Boolean(isAndroid() || isIos() || isOpera() || isWindows());
  const isDesktop = () => Boolean(!isMobile() && !isSSR());
  return {
    isMobile,
    isDesktop,
    isAndroid,
    isIos,
    isSSR,
    isWebView,
  };
};
const useMobileDetect = () => {
  const userAgent =
    typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
  return getMobileDetect(userAgent);
};

export default useMobileDetect;
